"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var clsx_1 = __importDefault(require("clsx"));
var RatingIcon_1 = __importDefault(require("./RatingIcon"));
var PREFIX = 'RatingNumber';
var classes = {
    rating: "".concat(PREFIX, "-rating"),
    badge: "".concat(PREFIX, "-badge"),
    notAvailable: "".concat(PREFIX, "-notAvailable"),
};
var Root = (0, styles_1.styled)('span')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(classes.rating)] = __assign(__assign({}, theme.typography.body1), { marginRight: theme.spacing(1) }),
        _b[".".concat(classes.badge)] = {
            padding: theme.spacing(0.25, 1.25),
            border: '#CCCCCC solid 1px',
            borderRadius: 13,
            marginRight: theme.spacing(0.5),
        },
        _b[".".concat(classes.notAvailable)] = {
            opacity: 0.5,
        },
        _b);
});
var RatingNumber = function (_a) {
    var rating = _a.rating, hasBadge = _a.hasBadge, singleDigit = _a.singleDigit;
    var notAvaiString = singleDigit ? '-' : 'N/A';
    var roundedAvgRating = rating ? (Math.round(rating * 10) / 10).toFixed(singleDigit ? 0 : 1) : notAvaiString;
    return ((0, jsx_runtime_1.jsxs)(Root, __assign({ className: (0, clsx_1.default)('color-primary', classes.rating, hasBadge && classes.badge, !rating && classes.notAvailable) }, { children: [(0, jsx_runtime_1.jsx)(RatingIcon_1.default, { rating: rating }), roundedAvgRating] })));
};
exports.default = RatingNumber;
